module.exports = __webpack_public_path__ + "img/Js jQuery Ajax.d404bbed.jpg";